import { styled, Tooltip, TooltipProps, tooltipClasses } from '@mui/material';

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip
        {...props}
        classes={{ popper: className }}
        slotProps={{
            popper: {
                sx: {
                    pointerEvents: 'none',
                },
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -16],
                        },
                    },
                ],
            },
        }}
    />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f8f8f8',
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 12,
        border: '1px solid #aaa',
    },
}));
